/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import DatagridEmptyBody from './DatagridEmptyBody';
import DatagridVirtualBody from './DatagridVirtualBody';
import DatagridSimpleBody from './DatagridSimpleBody';
import DatagridRefBody from './DatagridRefBody';

var DatagridBody = function DatagridBody(datagridState) {
  var isFetching = datagridState.isFetching,
      _datagridState$rows = datagridState.rows,
      rows = _datagridState$rows === void 0 ? [] : _datagridState$rows,
      withVirtualScroll = datagridState.withVirtualScroll,
      withStickyColumn = datagridState.withStickyColumn;

  if (!isFetching && rows.length === 0) {
    return /*#__PURE__*/React.createElement(DatagridEmptyBody, datagridState);
  }

  if (withVirtualScroll) {
    return /*#__PURE__*/React.createElement(DatagridVirtualBody, datagridState);
  }

  if (withStickyColumn) {
    return /*#__PURE__*/React.createElement(DatagridRefBody, datagridState);
  }

  return /*#__PURE__*/React.createElement(DatagridSimpleBody, datagridState);
};

export default DatagridBody;